// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesCauseTypesCodeCauseTypesResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesCauseTypesCodeCauseTypesResponse.attributeTypeMap;
    }
}
ClaimV1TypesCauseTypesCodeCauseTypesResponse.discriminator = undefined;
ClaimV1TypesCauseTypesCodeCauseTypesResponse.additionalProperties = false;
ClaimV1TypesCauseTypesCodeCauseTypesResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1TypesCauseTypesCodeCauseTypesResponse.js.map